module.exports = __webpack_public_path__ + "img/porteC_unlock.a29f17f4.svg";